// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","primary-color":"#027aff","where0":"NavBar_where0__74VTB"};